/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { TemplateTagsControllerRemoveTagMutationResponse, TemplateTagsControllerRemoveTagPathParams, TemplateTagsControllerRemoveTag401, TemplateTagsControllerRemoveTag403, TemplateTagsControllerRemoveTag404 } from "../../models/checklistsController/TemplateTagsControllerRemoveTag";

function getTemplateTagsControllerRemoveTagUrl(templateScopeId: TemplateTagsControllerRemoveTagPathParams["templateScopeId"], templateTagId: TemplateTagsControllerRemoveTagPathParams["templateTagId"]) {
  const res = { method: 'DELETE', url: `/api/v1/checklist-template-tags/assign/${templateScopeId}/${templateTagId}` as const }  
  return res
}

/**
 * @summary Remove a tag from a template family
 * {@link /api/v1/checklist-template-tags/assign/:templateScopeId/:templateTagId}
 */
export async function templateTagsControllerRemoveTag(templateScopeId: TemplateTagsControllerRemoveTagPathParams["templateScopeId"], templateTagId: TemplateTagsControllerRemoveTagPathParams["templateTagId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<TemplateTagsControllerRemoveTagMutationResponse, ResponseErrorConfig<TemplateTagsControllerRemoveTag401 | TemplateTagsControllerRemoveTag403 | TemplateTagsControllerRemoveTag404>, unknown>({ method : "DELETE", url : getTemplateTagsControllerRemoveTagUrl(templateScopeId, templateTagId).url.toString(), ... requestConfig })  
  return res.data
}